// window.location.href への直接代入をラップするヘルパー。
// jsdom では window.location を差し替えられないため、テストではこのモジュールをモックする。
export const navigateTo = (url: string): void => {
  window.location.href = url;
};
